import React from 'react';

function ResendIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 14 16"
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g fill="#0E0E11" fillRule="nonzero">
          <path
            d="M13.25,8 C13.25,6.058 12.37,4.26 10.837,3.065 C10.617,2.895 10.305,2.934 10.135,3.152 C9.965,3.37 10.004,3.684 10.222,3.854 C11.511,4.858 12.25,6.369 12.25,8 C12.25,10.895 9.895,13.25 7,13.25 C6.927,13.25 6.856,13.24 6.783,13.238 L7.762,12.373 C7.969,12.189 7.989,11.874 7.805,11.667 C7.623,11.46 7.307,11.441 7.1,11.623 L5.118,13.374 C5.011,13.469 4.949,13.605 4.949,13.749 C4.949,13.893 5.011,14.028 5.118,14.124 L7.1,15.876 C7.195,15.96 7.313,16.001 7.431,16.001 C7.569,16.001 7.707,15.944 7.806,15.832 C7.989,15.625 7.97,15.31 7.763,15.126 L6.756,14.236 C6.837,14.239 6.918,14.25 7,14.25 C10.446,14.25 13.25,11.446 13.25,8 Z"
          />
          <path
            d="M6.239,2.827 L5.292,3.665 C5.085,3.847 5.065,4.164 5.249,4.37 C5.348,4.482 5.485,4.539 5.624,4.539 C5.742,4.539 5.86,4.497 5.955,4.414 L7.955,2.646 C8.062,2.551 8.124,2.415 8.124,2.271 C8.124,2.127 8.062,1.991 7.955,1.896 L5.955,0.128 C5.748,-0.053 5.432,-0.035 5.249,0.172 C5.066,0.379 5.085,0.695 5.292,0.877 L6.322,1.788 C3.194,2.128 0.75,4.783 0.75,8 C0.75,9.43 1.22,10.774 2.108,11.891 C2.207,12.015 2.352,12.079 2.5,12.079 C2.609,12.079 2.719,12.044 2.811,11.971 C3.027,11.798 3.062,11.484 2.891,11.268 C2.144,10.331 1.75,9.201 1.75,8 C1.75,5.365 3.707,3.199 6.239,2.827 Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default ResendIcon;
